import api from './api'

/**
 * Human-readable labels for consent types (mirrors server CONSENT_TYPE_LABELS).
 */
export const CONSENT_TYPE_LABELS = {
  TUTORING_PARTICIPATION: 'Tutoring participation',
  RECORDING_AUDIO: 'Audio recording',
  RECORDING_VIDEO: 'Video recording',
  CHAT_PARTICIPATION: 'Chat participation',
  PUBLIC_DISCLOSURE: 'Public session attendance',
  INTERACTION_REVIEW: 'Interaction review',
  INDEPENDENT_TUTORING: 'Independent tutoring participation',
  INDEPENDENT_CONTRACTOR_ACK: 'Independent contractor acknowledgment',
  EVENT_TUTORING_PARTICIPATION: 'Tutoring session participation',
  EVENT_TUTORING_HOSTING: 'Tutoring session hosting',
  PLATFORM_FACILITATION_ACK: 'Platform facilitation acknowledgment'
}

const joinTypes = (types) => (Array.isArray(types) && types.length ? types.join(',') : undefined)

const consentService = {
  // Authenticated guardian
  getCurrentDocument: (slug) => api.get('/consent/documents/current', { params: { slug } }),
  getStudentStatus: (studentId, { slug, types } = {}) =>
    api.get(`/consent/students/${studentId}/status`, { params: { slug, types: joinTypes(types) } }),
  accept: (data) => api.post('/consent/accept', data),
  revoke: (data) => api.post('/consent/revoke', data),
  getMyAcceptances: () => api.get('/consent/my-acceptances'),
  acceptancePdfUrl: (id) => `/api/consent/acceptances/${id}/pdf`,
  requestWaiver: (data) => api.post('/consent/request', data),

  // Public email-token flow
  getWaiverByToken: (token) => api.get(`/consent/waiver/${token}`),
  acceptWaiverByToken: (token, data) => api.post(`/consent/waiver/${token}/accept`, data),
  declineWaiverByToken: (token) => api.post(`/consent/waiver/${token}/decline`),

  // Admin
  adminGetDocuments: (slug) => api.get('/consent/admin/documents', { params: { slug } }),
  adminPublishDocument: (data) => api.post('/consent/admin/documents', data),
  adminGetAcceptances: (params) => api.get('/consent/admin/acceptances', { params })
}

export default consentService
